import { Analytics } from 'analytics'

import { VERSION } from '../../utils/config'
import { isDebugEnabled } from '../../utils/debug'

import { epilotPlugin } from './plugin'

export const analyticsFactory = () => {
  return Analytics({
    app: 'journey-app-v3',
    version: VERSION,
    debug: isDebugEnabled(),
    plugins: [epilotPlugin()]
  })
}
